<template>
  <div>
    <b-row>
      <b-col cols="12" lg="4" xl="3">
        <component :is="filtersComponentName" @search="search($event)" :showIncludedInSubscriptionFilter="showIncludedInSubscriptionFilter"></component>
      </b-col>
      <b-col class="search-container" cols="12" lg="8" xl="9">
        <div class="search-result" v-if="(!inCompaniesSearch || $store.getters['session/userIsProfessional']) && data.length > 0">
          <div v-for="(item, index) in data" :key="item.profId || item.centerId">
            <search-banner-block v-if="index === 1"></search-banner-block>
            <search-block :profId="item.profId" :centerId="item.centerId" :rating="item.rating" :isFavourite="item.isFavourite" :customPageUrl="item.customPageUrl" :name="item.name" :surnames="item.surnames" :showProfLogo="item.showProfLogo" :specialties="item.specialties" :introductoryText="item.introductoryText" :centers="item.centers"
            :languages="item.languages" :attendInsurance="item.attendInsurance" :photoUri="item.photoUri" :gender="item.gender" :consultations="item.consultations" :nextInplaceAvailability="item.nextInplaceAvailability" :nextVideoAvailability="item.nextVideoAvailability"
            :nextInsuranceAvailability="item.nextInsuranceAvailability" :servicesPackages="item.servicesPackages" :patientTPlanaWebmailHired="item.patientTPlanaWebmailHired" :patientCompanyServices="item.patientCompanyServices" :patientHiredServicesPackages="item.patientHiredServicesPackages"
            :patientHasSpecialPrices="item.patientHasSpecialPrices" :specialCompanyPriceRatio="item.specialCompanyPriceRatio" :inplaceFirstAppointmentEnabled="item.inplaceFirstAppointmentEnabled" :inplaceFirstAppointmentPrice="item.inplaceFirstAppointmentPrice" :subspecialties="item.subspecialties" :minorRestricted="item.minorRestricted" :tarifaPlus="item.tarifaPlus" :accreditationState="item.accreditationState" 
            :searchDisabled="item.searchDisabled" :selectedService="selectedService"
            :centerTown="item.town" :patientInfo="patientInfo" @toggleIsFavourite="item.isFavourite = $event" @showMinorRestrictedEvent="showMinorRestrictedModal = true" @showInsurersEvent="getInsurers(item.insurers)" @showTarifaPlusDisabledEvent="showTarifaPlusDisabled"
            @showProfessionalPrevalidatedEvent="showProfessionalPrevalidated" @showAvailabilityRequestEvent="showAvailabilityRequest" @showServicesRequestEvent="showServicesRequest" @showInterconsultationModalEvent="showInterconsultationModalWithProfSelected" :profWithInterconsultationsActive="profWithInterconsultationsActive"></search-block>
          </div>
        </div>
        <div class="search-result" v-else-if="inCompaniesSearch && data.length > 0">
          <search-companies-block v-for="item in data" :key="item.profId" :profId="item.profId" :rating="item.rating" :customPageUrl="item.customPageUrl" :name="item.name" :surnames="item.surnames" :specialties="item.specialties" :introductoryText="item.introductoryText"
           :languages="item.languages" :photoUri="item.photoUri" :gender="item.gender" :subspecialties="item.subspecialties" :patientInfo="patientInfo"></search-companies-block>
        </div>
        <h5 class="text-center" v-else-if="emptySearch" v-html="$t('filters.emptySearch')"></h5>
        <h5 class="text-center" v-else v-html="$t('filters.selectFilter')"></h5>
      </b-col>
    </b-row>
    <base-dialog v-model="showMinorRestrictedModal" :content="$t('minorRestricted')" :okFn="() => { showMinorRestrictedModal = false }"></base-dialog>
    <base-dialog v-model="showInsurers" :content="insurers" :title="$t('insurances')" :okBtnText="$t('close')" :okFn="() => { showInsurers = false }"></base-dialog>
    <tarifa-plus-disabled-modal v-model="showTarifaPlusDisabledModal" :userId="userId" :isProfUser="isProfUser"></tarifa-plus-disabled-modal>
    <professional-prevalidated-modal v-model="showProfessionalPrevalidatedModal" :profId="userId"></professional-prevalidated-modal>
    <availability-request-modal v-model="showAvailabilityRequestForm" :profId="availabilityRequestData.profId" :specialties="availabilityRequestData.specialties" :companyServices="availabilityRequestData.companyServices" :appointmentTypeSelected="availabilityRequestData.currentSelectedServiceId"></availability-request-modal>
    <services-request-modal v-model="showServicesRequestForm" :userId="serviceRequestData.userId" :selectedService="serviceRequestData.serviceId"></services-request-modal>
    <administrative-chat-modal :selectedProf="profNameAndPhoto"></administrative-chat-modal>
    <arrow-up></arrow-up>
  </div>
</template>
  
  <script>
  import SearchBlock from './SearchBlock.vue'
  import SearchFilters from './SearchFilters.vue'
  import SearchFiltersProfessional from '@/components/webapp/professional/interconsultations/SearchFiltersProfessional.vue'
  import SearchBannerBlock from './SearchBannerBlock.vue'
  import SearchCompaniesFilters from './companies/SearchCompaniesFilters.vue'
  import SearchCompaniesBlock from './companies/SearchCompaniesBlock.vue'
  import searchRepository from '@/repositories/SearchRepository'
  import patientsRepository from '@/repositories/PatientsRepository'
  import TarifaPlusDisabledModal from '@/components/shared/TarifaPlusDisabledModal.vue'
  import ProfessionalPrevalidatedModal from './ProfessionalPrevalidatedModal.vue'
  import AvailabilityRequestModal from '@/components/shared/AvailabilityRequestModal.vue'
  import ServicesRequestModal from '@/components/shared/ServicesRequestModal.vue'
  import BaseDialog from '@/components/base/BaseDialog.vue'
  import { inOpensalud360 } from '@/constants/platformNames'
  import { CENTER, PROFESSIONAL } from '@/constants/search'
  import ArrowUp from '@/components/shared/ArrowUp'
  import AdministrativeChatModal from '@/components/views/chat-interconsultations/AdministrativeChatModal.vue'
  import ProfessionalRateRepository from '@/repositories/ProfessionalRateRepository'
  import { INTERCONSULTATION } from '@/constants/consultationTypes'
  
  const SEARCH_MAX_ITEMS = 3
  const COMPANIES_SEARCH_MAX_ITEMS = 5
  const SEARCH_LI_INCREMENT = 3
  const SEARCH_LI_DEFULT = 2
  
  export default {
      components: {
          SearchBlock,
          SearchFilters,
          SearchFiltersProfessional,
          SearchCompaniesFilters,
          SearchCompaniesBlock,
          TarifaPlusDisabledModal,
          ProfessionalPrevalidatedModal,
          AvailabilityRequestModal,
          ServicesRequestModal,
          BaseDialog,
          SearchBannerBlock,
          ArrowUp,
          AdministrativeChatModal
      },
      data () {
        return {
          selectedService: null,
          patientInfo: null,
          emptySearch: false,
          scTimer: 0,
          liCount: 2,
          currentPage: 0,
          pageSize: 5,
          data: [],
          filters: {},
          showMinorRestrictedModal: false,
          showTarifaPlusDisabledModal: false,
          showProfessionalPrevalidatedModal: false,
          showAvailabilityRequestForm: false,
          showServicesRequestForm: false,
          showInsurers: false,
          insurers: null,
          userId: null,
          availabilityRequestData: {},
          serviceRequestData: {},
          profNameAndPhoto: {},
          profWithInterconsultationsActive: false
        }
      },
      created () {
        if (this.$store.getters['session/userIsPatient']) {
          patientsRepository.getPatientInfo().then(response => {
            if (response.data) {
              this.patientInfo = response.data || {}
            }
          })
        } else if (this.$store.getters['session/userIsProfessional']) {
          ProfessionalRateRepository.getProfRateById(INTERCONSULTATION).then((response) => {
            if (response.data) {
              this.profWithInterconsultationsActive = response.data.active
            }
          })
        }
        this.$store.commit('chat/hideAllDialogs')
      },
      mounted () {
        window.addEventListener('scroll', this.handleScroll)
      },
      methods: {
        handleScroll: function () {
          if (this.scTimer) return
          if (location.href.indexOf('/search') === -1 || location.href.indexOf('/search/services') > -1) {
            window.removeEventListener('scroll', this.handleScroll)
            return
          }
          this.scTimer = setTimeout(() => {
            let scrollY = window.scrollY
            let lastItem = document.querySelector(`.search-container .search-result > div:nth-child(${this.liCount})`)
            if (this.currentPage >= 1 && lastItem && lastItem.offsetTop < scrollY) {
              this.getNextSearchItems().then(response => {
                clearTimeout(this.scTimer)
                this.scTimer = 0
              })
            } else {
              clearTimeout(this.scTimer)
              this.scTimer = 0
            }
          }, 300)
        },
        resetSearch () {
          this.currentPage = 0
          this.liCount = SEARCH_LI_DEFULT
        },
        search (filters) {
          this.resetSearch()
          this.selectedService = filters.appointmentType
          this.filters = filters
          searchRepository[this.inCompaniesSearch ? 'getCompaniesProfessionals' : this.filters.userType === CENTER ? 'getCenters' : 'getProfessionals'](this.filters).then((response) => {
              if (response.data.data) {
                this.data = response.data.data
                this.emptySearch = this.data.length === 0
                document.getElementsByClassName('search-container')[0].scrollIntoView({behavior: 'smooth'})
                if (this.data.length === (this.inCompaniesSearch ? COMPANIES_SEARCH_MAX_ITEMS : SEARCH_MAX_ITEMS)) this.getNextSearchItems()
              }
          })
        },
        getNextSearchItems () {
          let filters = this.filters
          filters.pageSize = this.pageSize
          if (!this.inCompaniesSearch) filters.itemsToSkip = this.itemsToSkip
          if (this.inCompaniesSearch) filters.professionalsIdShowed = this.data.map(item => item.profId)
          return searchRepository[this.inCompaniesSearch ? 'getCompaniesProfessionals' : this.filters.userType === CENTER ? 'getCenters' : 'getProfessionals'](filters, true).then((response) => {
              if (response.data.data) {
                this.data.push(...response.data.data)
                this.liCount += SEARCH_LI_INCREMENT
                this.currentPage++
              }
          })
        },
        showTarifaPlusDisabled (userId) {
          this.userId = userId
          this.showTarifaPlusDisabledModal = true
        },
        showProfessionalPrevalidated (profId) {
          this.userId = profId
          this.showProfessionalPrevalidatedModal = true
        },
        showAvailabilityRequest (data) {
          this.availabilityRequestData = data
          this.showAvailabilityRequestForm = true
        },
        showServicesRequest (data) {
          this.serviceRequestData = data
          this.showServicesRequestForm = true
        },
        showInterconsultationModalWithProfSelected (data) {
          this.profNameAndPhoto = data
          this.$store.commit('chat/toggleShowDialog', 'create')
        },
        getInsurers (insurers) {
          if (insurers && insurers.length > 0) {
              this.insurers = insurers.map(item => {
                return item.name
              }).join(', ')
              this.showInsurers = true
            }
        }
      },
      computed: {
        filtersComponentName () {
          if (this.$store.getters['session/userIsProfessional']) return 'search-filters-professional'
          return this.inCompaniesSearch ? 'search-companies-filters' : 'search-filters'
        },
        itemsToSkip () {
          return SEARCH_MAX_ITEMS + (this.currentPage * this.pageSize)
        },
        inCompaniesSearch () {
          return inOpensalud360()
        },
        isProfUser () {
          return this.filters.userType === PROFESSIONAL
        },
        companiesSearchEnabled () {
          return this.patientInfo && !this.patientInfo.companiesSearchDisabled
        },
        showIncludedInSubscriptionFilter () {
          return this.companiesSearchEnabled && this.patientInfo.companyCode && this.patientInfo.validCode
        }
      }
  }
  </script>
  
  <style lang="scss" scoped>
  .search-result{
    @include screen-lg-grid  {
      padding-left: 3rem;
    }
  }
  /deep/ .search-result .neu-card{
    @include screen-xl-grid-max  {
        padding: 1.5rem;
    }
  }
  /deep/ .search-container .search-result > div:nth-child(2n) > div.neu-card{
    background-color: #e4e4e4;
  }
  </style>


// WEBPACK FOOTER //
// src/components/webapp/patient/search/Search.vue